import { useAtom } from "jotai";
import { atomWithStorage } from "jotai/utils";

import type { TradeType } from "#/types/trade";

export const optionTradeTypeAtom = atomWithStorage<TradeType>(
  "optionTradeType",
  "market",
);

export const useOptionTradeType = () => {
  const [optionTradeType, setOptionTradeType] = useAtom(optionTradeTypeAtom);

  const isMarket = optionTradeType === "market";
  const isLimit = optionTradeType === "limit";
  const isRFQ = optionTradeType === "rfq";

  return {
    isMarket,
    isLimit,
    isRFQ,
    optionTradeType,
    setOptionTradeType,
  };
};
